
import { PlanCard } from "@/components/pricing/PlanCard";
import { PricingToggle } from "@/components/pricing/PricingToggle";
import { OrganizationSelector } from "@/components/pricing/OrganizationSelector";
import { usePricingPlans } from "@/hooks/usePricingPlans";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { 
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from "@/components/ui/breadcrumb";

const PricingPlans = () => {
  const {
    plans,
    isLoading,
    isYearly,
    setIsYearly,
    selectedOrgId,
    setSelectedOrgId,
    userOrgs,
    handleSelectPlan
  } = usePricingPlans();
  
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <p className="text-lg">Chargement des plans d'abonnement...</p>
      </div>
    );
  }

  return (
    <div className="bg-pastel-blue-light min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Button 
                    variant="ghost" 
                    className="gap-1 pl-0" 
                    onClick={() => navigate(-1)}
                  >
                    <ArrowLeft className="h-4 w-4" />
                    Retour
                  </Button>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <span>Plans d'abonnement</span>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Choisissez votre plan</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
            Sélectionnez le forfait qui correspond le mieux aux besoins de votre organisation.
          </p>
          
          <OrganizationSelector 
            userOrgs={userOrgs} 
            selectedOrgId={selectedOrgId} 
            setSelectedOrgId={setSelectedOrgId} 
          />
          
          <PricingToggle isYearly={isYearly} setIsYearly={setIsYearly} />
        </div>
        
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 max-w-6xl mx-auto">
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              isYearly={isYearly}
              selectedOrgId={selectedOrgId}
              onSelectPlan={handleSelectPlan}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
